var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartlyCloudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 24C36 17.3726 30.6274 12 24 12C18.054 12 13.1181 16.3246 12.1659 22C11.6986 28.8008 26.8727 30.0211 34.5182 29.7811C35.4626 28.0664 36 26.096 36 24Z",
    fill: "#FFE6B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2V4M38.1418 9.85791L39.5561 8.4437M8.44336 8.44373L9.85757 9.85794M44 24.0001H46M24 12C30.6274 12 36 17.3726 36 24C36 26.096 35.4626 28.0664 34.5182 29.7811C26.8727 30.0211 11.6986 28.8008 12.1659 22C13.1181 16.3246 18.054 12 24 12Z",
    stroke: "#EAAC30",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1902 45.4582C5.86535 43.9367 2 39.3821 2 34C2 27.3726 7.861 22 15.0909 22C19.9364 22 24.167 24.4132 26.4305 28H29C33.9706 28 38 32.0294 38 37C38 41.9706 33.9706 46 29 46H14.2727C13.1899 46 12.1517 45.8088 11.1902 45.4582Z",
    fill: "#D9DBE9",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartlyCloudy);
export default __webpack_public_path__ + "static/media/partly-cloudy.a92cac2580cea257e607fa2ea50d635a.svg";
export { ForwardRef as ReactComponent };